import { useState } from 'react';
import { Link } from 'react-router-dom';
import SimpleArrowDown from '@/styles/Icons/SimpleArrowDown';
import { formatRelativeDate } from '@/utils/helpers/formatTimeDate';
import { truncateContent, truncateEntry } from '@/utils/helpers/strings';
import ProfileLink from '@/scenes/Management/Community/ProfileLink';
import { DiscussionComments } from './DiscussionComments';
import css from './DiscussionsPage.module.css';
import type { DiscussionGroup } from './types';

interface Props {
  group: DiscussionGroup;
  showBlogColumn: boolean;
}

export function DiscussionItem({ group, showBlogColumn }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { entryId, entry, blogSlug, notifications, hasUnread, unreadCount, latestAt } = group;

  const entryHref = `/blog/${blogSlug}/${entryId}`;

  const entryTitle = truncateEntry(entry, 50);
  const contentText = truncateContent(entry.content);
  const totalCount = notifications.length;
  const dateLabel = latestAt ? formatRelativeDate(latestAt) : '';

  return (
    <>
      <div
        className={`${css.tableRow}${hasUnread ? ` ${css.tableRowUnread}` : ''}${
          isExpanded ? ` ${css.tableRowExpanded}` : ''
        }`}
      >
        <div className={css.colExpand}>
          <button
            className={`${css.chevronBtn}${isExpanded ? ` ${css.chevronBtnExpanded}` : ''}`}
            onClick={() => setIsExpanded(v => !v)}
            aria-label={isExpanded ? 'Свернуть' : 'Развернуть'}
          >
            <SimpleArrowDown className={css.chevronIcon} />
          </button>
        </div>

        <div className={css.colTopic}>
          <div className={css.topicContent}>
            <div className={css.entryTitleRow}>
              {unreadCount > 0 && (
                <span className={`${css.unreadMessagesCollapsed} ${css.unreadMessagesMark}`}>{unreadCount}</span>
              )}
              <Link to={entryHref} className={`${css.entryLink}${hasUnread ? ` ${css.entryLinkUnread}` : ''}`}>
                {entryTitle}
              </Link>
            </div>
            {contentText && <div className={css.entryContent}>{contentText}</div>}
          </div>
        </div>

        {showBlogColumn && (
          <div className={css.colBlog}>
            {entry.profile ? (
              <ProfileLink profile={entry.profile} link={`/profile/${entry.profile.id}`}>
                <span className={css.blogTitle}>{entry.profile.blogTitle}</span>
              </ProfileLink>
            ) : null}
          </div>
        )}

        <div className={css.colComments}>
          {unreadCount > 0 && (
            <>
              <div className={css.unreadMessagesMark}>{unreadCount}</div>
              <span>{' / '}</span>
            </>
          )}
          {totalCount}
        </div>

        <div className={css.colDate}>{dateLabel}</div>
      </div>

      {isExpanded && <DiscussionComments notifications={notifications} blogSlug={blogSlug} entryId={entryId} />}
    </>
  );
}
